import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';
import TeamDrawPlayers from './TeamDrawPlayers';

function AllGeneratedTeamsRound({id, roundId, roundData, registeredPlayers}) {

    const [teams, setTeams] = useState([]);

    useEffect(() => {

        console.log(registeredPlayers, "registered players ALLGENERATEDTEAMSROUNDN")

        const teamsRoundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("teams");
        teamsRoundRef.orderBy("draw").onSnapshot(({docs}) => {
            const teams = docs.map(doc => {
                return {id: doc.id, ...doc.data()}
            });
            setTeams(teams);
            console.log(teams, "TEAMS")
        })

    }, [])

    async function deleteHandler(e, teamId) {
        e.preventDefault();
        try {
            const teamRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("teams").doc(teamId);
            teamRef.delete();
        } catch (error) {
            
        }
    }

    return (
        <div>
            <h4 className="my-5 text-center font-weight-bold">{teams.length ? "Alle lag": "Ingen lag trukket enda"} (All Generated Teams Round)</h4>
            
            <div className="row">
                {teams?.map((team, index) => {
                    return (
                        <div className="col-md-4" key={index}>
                            <p className="font-weight-bold">
                                Trekning {team.draw} (lagret) <span className="float-right"><i onClick={(e) => deleteHandler(e, team.id)} className="fas fa-trash text-danger"></i></span>
                            </p>
                            <TeamDrawPlayers 
                                draw={team.teams} 
                                drawId={team.id}
                                drawNumber={team.draw} 
                                type="Saved" 
                                hostcupId={id}
                                roundId={roundId}
                                roundData={roundData}
                                registeredPlayers={registeredPlayers}
                            /> 
                        </div>
                    ) 
                })}
            </div>

            <h3>Rediger lag</h3>



        </div>
    )

}
export default AllGeneratedTeamsRound